import utils from "@/utils/index";
export default{
  updateShowpath(state,newStr){
    state.showpath = newStr;
  },
  updateUserInfo(state,obj){
    state.userInfo = obj
    utils.setCookie('login',JSON.stringify(obj),30)
  },
  // 更新责任方式
  updateDutyList(state,info){
    state.dutyList = info
  },

  // 更新奖项方式
  updateWardList(state,info){
    state.awardList = info
  },

  updateLevelLity(state,info){
    state.levelList = info
  },

  updateSearchProgram(state,info){
    state.SearchProgram= info
  },

  updateExhibitProgram(state,info){
    state.SearchExhibit= info
  },

  updateCateByName(state, {list, name}){
    state[name] = list
  },

  // 更新关于我们的文字
  updateAboutContent(state,info){
    state.aboutContent = info
  },
  // 更新登录数次
  updateLoginTime(state, time, account){
    state.loginTimes =  time
    if(time==5){
      state.loginDisTime = new Date().getTime()
      state.lockCount = account
    }
    if(time==0){
      state.loginDisTime = ''
      state.lockCount = ''
    }
  },

  updateList(state,obj){
    let name = obj.name, list = obj.list
    state[name] =  list
  },

  getUserInfo(state,obj){
    let userInfo = utils.getCookie('login')
    userInfo = userInfo?JSON.parse(userInfo):null; 
    if(!userInfo || !userInfo.id){
      userInfo = null
    }
    if(!userInfo){
      utils.deleteCookie("login")
    }
    state.userInfo = userInfo
  }
  
}